import React from 'react';
import ChartAccount from './Chart_Of_Accounts';
import '../../../CommonCSS/SocietyCSS.css'

const ChartAccntApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Chart Of Accounts</h5>
          </div>
        </div>
        <ChartAccount />
      </div>
    </div >
  );
};

export default ChartAccntApp;
